export default {
  init() {
    // JavaScript to be fired on the home page
      let latestNewsSlider = $('.latest-news-wrapper-slider');

      if($(window).width() < 992){
          latestNewsSlider.slick({
              dots: true,
              autoplay: true,
              infinite: true,
              appendDots: $('.news-dots'),
              arrows: false,
              adaptiveHeight: true,
          });
      }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js